import { isBrowser } from '@migros/msrc-browser';
import { Box, styled } from '@migros/msrc-ui-kit';
import React from 'react';
export const ArticleImage = ({
  alt,
  retinaSrc,
  src
}) => {
  // eslint-disable-next-line
  if (!(isBrowser() && 'objectFit' in document.documentElement.style)) {
    return /*#__PURE__*/React.createElement(StyledPolyfilledArticleImage, {
      imgSrc: src
    });
  }
  return /*#__PURE__*/React.createElement(StyledArticleImage, {
    src: src,
    srcSet: retinaSrc ? `${retinaSrc} 2x, ${src} 1x` : undefined,
    alt: alt,
    loading: "lazy",
    "data-testid": "msrc-articles--article-image"
  });
};
const StyledArticleImage = styled.img`
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  object-fit: contain;
`;
const StyledPolyfilledArticleImage = styled(Box)`
  width: 100%;
  height: 100%;
  background-image: url('${({
  imgSrc
}) => replaceQuotes(imgSrc)}');
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
`;
const replaceQuotes = input => input.replace(/"/g, '\\"');